import { Camera, Video, Heart, Sparkles, Film, Users, Building, Music, Calendar, Star, Briefcase, Image } from 'lucide-react';

export type BusinessType = 'photographer' | 'videographer' | 'production_studio' | 'hybrid';

export interface ServiceTabConfig {
  id: string;
  label: string;
  icon: string;
}

export const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  camera: Camera,
  video: Video,
  heart: Heart,
  sparkles: Sparkles,
  film: Film,
  users: Users,
  building: Building,
  music: Music,
  calendar: Calendar,
  star: Star,
  briefcase: Briefcase,
  image: Image,
};

export const availableIcons = Object.keys(iconMap);

export const businessTypeLabels: Record<BusinessType, string> = {
  photographer: 'Photographer',
  videographer: 'Videographer',
  production_studio: 'Production Studio',
  hybrid: 'Hybrid (Photo + Video)',
};

export const businessTypeDescriptions: Record<BusinessType, string> = {
  photographer: 'Portrait, event, and commercial photography',
  videographer: 'Wedding films, commercials, and video production',
  production_studio: 'Full-service film and content production',
  hybrid: 'Combined photography and videography services',
};

export const serviceTabPresets: Record<BusinessType, ServiceTabConfig[]> = {
  photographer: [
    { id: 'portraits', label: 'Portrait Sessions', icon: 'camera' },
    { id: 'events', label: 'Events', icon: 'calendar' },
    { id: 'commercial', label: 'Commercial', icon: 'briefcase' },
    { id: 'mini_sessions', label: 'Mini Sessions', icon: 'sparkles' },
  ],
  videographer: [
    { id: 'commercial_films', label: 'Commercial Films', icon: 'film' },
    { id: 'wedding_films', label: 'Wedding Films', icon: 'heart' },
    { id: 'event_coverage', label: 'Event Coverage', icon: 'video' },
    { id: 'music_videos', label: 'Music Videos', icon: 'music' },
  ],
  production_studio: [
    { id: 'commercial', label: 'Commercial', icon: 'building' },
    { id: 'brand_films', label: 'Brand Films', icon: 'star' },
    { id: 'documentary', label: 'Documentary', icon: 'film' },
    { id: 'music_videos', label: 'Music Videos', icon: 'music' },
  ],
  hybrid: [
    { id: 'weddings', label: 'Weddings', icon: 'heart' },
    { id: 'commercial', label: 'Commercial', icon: 'briefcase' },
    { id: 'events', label: 'Events', icon: 'calendar' },
    { id: 'portraits', label: 'Portraits', icon: 'camera' },
  ],
};

export const getDefaultServiceTabs = (): ServiceTabConfig[] => [
  { id: 'general', label: 'General Inquiries', icon: 'sparkles' },
];
